const { host } = window.location;

export const getEnv = () => {
  if (host.includes('localhost')) return 'dev';
  if (host.includes('returns-qa') || host.includes('returns.qa')) return 'qa';
  if (host.includes('returns-st') || host.includes('returns.st')) return 'st';
  return 'production';
};

const env = getEnv();

const SUTRO = {
  dev: 'https://sutro.qa20.narvar.qa',
  qa: 'https://sutro.qa20.narvar.qa',
  st: 'https://sutro.st20.narvar.com',
  production: 'https://sutro.prod20.narvar.com',
};

const NEOHUB = {
  dev: 'https://hubn-qa01.narvar.qa',
  qa: 'https://hubn-qa01.narvar.qa',
  st: 'https://hubn-st01.narvar.qa',
  production: 'https://hubn.narvar.com',
};

const LOMA = {
  dev: 'https://loma-cdn.domain-cpmt-platform.qa20.narvar.qa/graphql',
  qa: 'https://loma-cdn.domain-cpmt-platform.qa20.narvar.qa/graphql',
  st: 'https://loma-cdn.domain-cpmt-platform.st20.narvar.com/graphql',
  production: 'https://loma-cdn.domain-cpmt-platform.prod20.narvar.com/graphql',
};

export const SUTRO_HOST = SUTRO[env];
export const NEOHUB_HOST = NEOHUB[env];
export const LOMA_URL = LOMA[env];
